/**
 * Customer-facing contact details shown in the chrome + copy.
 *
 * Centralized here (not scattered as inline literals) so it is trivial to source
 * from live config later. TODO(config): serve these from the Worker /pricing or
 * a shop-settings endpoint rather than baking them in.
 */
export const CONTACT = {
  phone: '(02) 8041 7049',
  email: 'mail@rewindphotolab.com.au',
} as const;

/**
 * Help-center article: "Preparing your files for print". Linked from the upload
 * screen's GOOD TO KNOW card (and anywhere else the "Preparing your files" copy
 * appears). Kept here so the URL lives in one place if the help center moves.
 */
export const PREPARING_FILES_GUIDE_URL =
  'https://rewindphotolab.com.au/pages/help-center?hcUrl=%2Fen-US%2Fpreparing-your-files-for-print-4129801';

/**
 * Delivery promise on the upload screen: the desktop GOOD TO KNOW card and the
 * line under the mobile title. The interstate fine art ads land on this screen
 * (owner 2026-10-06), so delivery comes first; local customers still see their
 * pickup stores. No shipping prices here by owner ruling.
 */
export const DELIVERY_PROMISE =
  'Printed in our Sydney lab. Delivered anywhere in Australia, or pick up in Sydney or Wollongong.';
